module.exports = __webpack_public_path__ + "static/img/大数据_bj@2x.2b181cf8.png";